import React from 'react'
import styles from './index.module.scss'
import GiantLogo from '../../../../../images/GiantLogo.jpg'
import { FormattedMessage } from 'react-intl'
import SidebarMenu from 'react-bootstrap-sidebar-menu'
import { useLocation, Link } from 'react-router-dom'

const Sidebar = ({ accessList, adittionalRoutes, routesReportPending }) => {
  const location = useLocation();

  return (
    <SidebarMenu
      className={`text-muted sidebar-menu-full ${styles.SidebarMenu}`}
      as="div"
      exclusiveExpand={false}
      collapseOnSelect={false}
      variant="dark"
      bg="dark"
      rtl={true}
      expand={false}
      defaultExpanded={true}
    >
      <SidebarMenu.Collapse>
        <SidebarMenu.Header>
          <SidebarMenu.Brand title="GiantSys Tracking" className={styles.SidebarMenuBrand}>
            <FormattedMessage id='giantLogoAlt' defaultMessage="GiantSys logo">{(msg) => (<img className={styles.GiantLogo} src={GiantLogo} alt={msg} />)}</FormattedMessage>
          </SidebarMenu.Brand>
          <SidebarMenu.Toggle/>
        </SidebarMenu.Header>
        <SidebarMenu.Body>
          <SidebarMenu.Nav>
            {accessList.map((Access, i) => (
              <SidebarMenu.Nav.Link key={i} className={`/${Access.href}` === location.pathname ? `${styles.SidebarMenuItem} ${styles.SidebarMenuActive}` : styles.SidebarMenuItem }>
                <Link to={Access.href} className={styles.SidebarMenuItem}>
                  <SidebarMenu.Nav.Icon className={styles.SidebarMenuIcon} title={Access.title}>{i+1}</SidebarMenu.Nav.Icon>
                  <SidebarMenu.Nav.Title>{Access.title}</SidebarMenu.Nav.Title>
                </Link>
              </SidebarMenu.Nav.Link>
            ))}
            {routesReportPending.map((Report, i) => (
              <div key={i} className="sidebar-menu-nav-link" >
                <Link to={Report.href} className={styles.SidebarMenuItem} target="_blank" rel="noopener noreferrer">
                  <SidebarMenu.Nav.Icon className={styles.SidebarMenuIcon} title={Report.title}>{Report.icon}</SidebarMenu.Nav.Icon>
                  <SidebarMenu.Nav.Title>{Report.title}</SidebarMenu.Nav.Title>
                </Link>
              </div>
            ))}
            {adittionalRoutes}
          </SidebarMenu.Nav>
        </SidebarMenu.Body>
      </SidebarMenu.Collapse>
    </SidebarMenu>   
  );
};

export default Sidebar;
